import Select from 'lib/components/select/Select';
import useDynamicModificationRules from 'lib/useDynamicModificationRules';
import testId from './fixtures/testid';

const NO_RULE = { value: null, label: 'None' };

function DynamicRuleWidget({ isInModal, data, onChange, menuPlacement }) {
  const { isEnabled, options } = useDynamicModificationRules();
  if (!isEnabled) return null;

  const ruleId = data.dynamicModificationRuleId?.value;
  const selectOptions = [NO_RULE, ...options];
  const selected =
    selectOptions.find((option) => option.value === Number(ruleId)) ?? NO_RULE;

  return (
    <>
      <div className='form-label'>Dynamic modification rule</div>
      <Select
        data-testid={testId.dynamicModificationRuleSelect}
        isInModal={isInModal}
        className='dynamic-rule-select'
        options={selectOptions}
        value={selected}
        onChange={(option) => onChange('dynamicModificationRuleId', option?.value ?? null)}
        errors={data.dynamicModificationRuleId?.errors}
        menuPlacement={menuPlacement}
      />
    </>
  );
}

export default DynamicRuleWidget;
